import { render, staticRenderFns } from "./dlgl.vue?vue&type=template&id=7e8c7ace&scoped=true"
import script from "./dlgl.vue?vue&type=script&lang=js"
export * from "./dlgl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8c7ace",
  null
  
)

export default component.exports